import React from "react";
import { motion } from "framer-motion";
import { StarIcon, BadgeCheckIcon } from "lucide-react";
const testimonials = [{
  name: "Martín G.",
  role: "Diseñador · Buenos Aires",
  text: "Cerré mi primer contrato de $1.200 USD dos semanas después de aplicar los prompts. El cliente ni se imaginó que no soy nativo.",
  initials: "MG"
}, {
  name: "Valentina R.",
  role: "Copywriter · Bogotá",
  text: "Pasé de cobrar en pesos a facturar $3.500 al mes en dólares. El script de propuestas es oro puro.",
  initials: "VR"
}, {
  name: "Diego S.",
  role: "Agencia · Ciudad de México",
  text: "Mi tasa de respuesta en LinkedIn se triplicó. Ahora los clientes de USA me escriben a mí primero.",
  initials: "DS"
}, {
  name: "Camila P.",
  role: "Freelancer · Santiago",
  text: "Por $6 me llevé un sistema completo. Ya recuperé la inversión mil veces. Absurdo lo barato que está.",
  initials: "CP"
}];
export function Testimonials() {
  return <section className="w-full bg-[#0a0a1f] py-16" data-id="element-209" data-mp="h4wtby0nm4g3">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-210" data-mp="m51dby0rthb2">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-211" data-mp="m5t14mo4maqs">
          Latinos que ya juegan en la{" "}
          <span className="text-violet-400" data-id="element-212" data-mp="c6vczkum4j8b">liga del dólar</span>
        </h2>
        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-213" data-mp="c73nj639jcgc">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-id="element-214" data-mp="zyix9jxdcw1m" data-mpi={i}>
              <div className="flex text-amber-400" data-id="element-215" data-mp="1iusay64czkl3">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-current" data-id="element-216" data-mp="1nn23zv0rt0rl" data-mpi={s} />)}
              </div>
              <blockquote className="mt-3 text-slate-200" data-id="element-217" data-mp="1xgplvh3fl0ap">"{t.text}"</blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-218" data-mp="1sio3kydtx50a">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-violet-500/20 font-display font-bold text-violet-200" data-id="element-219" data-mp="1ohatgc3pefnk">
                  {t.initials}
                </div>
                <div data-id="element-220" data-mp="1ej4vu6oxjvoi">
                  <p className="flex items-center gap-1 font-semibold text-white" data-id="element-221" data-mp="1ejoa9dfdg1xs">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-emerald-400" data-id="element-222" data-mp="19rddukjuay9z" />
                  </p>
                  <p className="text-xs text-slate-400" data-id="element-223" data-mp="14ud7s9mzpviv">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}